// extracted by mini-css-extract-plugin
export default {"root":"IconEmailAttention_root__jr3PC","marketplaceStroke":"IconEmailAttention_marketplaceStroke__s7+Tu","attentionStroke":"IconEmailAttention_attentionStroke__7sccP"};